import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const cycleCountRuleListItem = z.object({
  id: cycleCountRuleIdFormat.schema,
  name: z.string(),
  description: z.string().nullable(),
  type: z.literal("abc"),
  status: z.enum(["live", "disabled"]),
  data: z.unknown(),
  dueDaysAfterCreation: z.int(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const listCycleCountRules = unaryRpc({
  name: "listCycleCountRules" as const,
  input: z.object({}),
  output: z.object({ rules: z.array(cycleCountRuleListItem) }),
});
